import { useEffect } from 'react'
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'

export const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-2xl shadow-sm p-8 sm:p-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
              Termos de Uso
            </h1>
            <p className="text-sm text-gray-500 mb-8">
              Última atualização: 21 de janeiro de 2026
            </p>

            <div className="prose prose-gray max-w-none">
              {/* Índice */}
              <nav className="bg-gray-50 rounded-lg p-6 mb-8">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">Índice</h2>
                <ol className="list-decimal list-inside space-y-2 text-primary-600">
                  <li><a href="#definicoes" className="hover:underline">Definições</a></li>
                  <li><a href="#objeto" className="hover:underline">Objeto do Serviço</a></li>
                  <li><a href="#cadastro" className="hover:underline">Cadastro e Acesso</a></li>
                  <li><a href="#planos" className="hover:underline">Planos, Preços e Pagamento</a></li>
                  <li><a href="#trial" className="hover:underline">Período de Teste (Trial)</a></li>
                  <li><a href="#obrigacoes" className="hover:underline">Obrigações do Usuário</a></li>
                  <li><a href="#propriedade" className="hover:underline">Propriedade Intelectual</a></li>
                  <li><a href="#responsabilidade" className="hover:underline">Limitação de Responsabilidade</a></li>
                  <li><a href="#suspensao" className="hover:underline">Suspensão e Cancelamento</a></li>
                  <li><a href="#disposicoes" className="hover:underline">Disposições Gerais</a></li>
                </ol>
              </nav>

              {/* 1. Definições */}
              <section id="definicoes" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Definições</h2>
                <p className="text-gray-700 mb-4">
                  Para os fins destes Termos de Uso, consideram-se as seguintes definições:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li><strong>"Projetoize"</strong> ou <strong>"Plataforma"</strong>: refere-se ao software como serviço (SaaS) de gestão de projetos e tarefas disponibilizado através do site projetoize.com.br e suas aplicações.</li>
                  <li><strong>"Usuário"</strong>: toda pessoa física ou jurídica que acessa ou utiliza a Plataforma, seja como Administrador ou Colaborador.</li>
                  <li><strong>"Administrador"</strong>: usuário responsável pela conta principal do Tenant, com poderes de gestão completa.</li>
                  <li><strong>"Colaborador"</strong>: usuário convidado pelo Administrador com acesso limitado aos projetos atribuídos.</li>
                  <li><strong>"Tenant"</strong>: ambiente isolado e exclusivo de cada organização dentro da Plataforma.</li>
                  <li><strong>"Conteúdo do Usuário"</strong>: todos os dados, informações, arquivos e materiais inseridos pelo Usuário na Plataforma.</li>
                </ul>
              </section>

              {/* 2. Objeto do Serviço */}
              <section id="objeto" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Objeto do Serviço</h2>
                <p className="text-gray-700 mb-4">
                  2.1. O Projetoize é uma plataforma de gestão de projetos e tarefas oferecida no modelo Software como Serviço (SaaS), que permite aos Usuários:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Criar e gerenciar projetos com colaboradores;</li>
                  <li>Organizar tarefas e subtarefas com prazos e responsáveis;</li>
                  <li>Utilizar visualização Kanban e dashboards;</li>
                  <li>Definir e acompanhar OKRs (Objetivos e Resultados-Chave);</li>
                  <li>Gerenciar equipes e controlar permissões;</li>
                  <li>Centralizar documentos e comunicações;</li>
                  <li>Planejar e executar sprints;</li>
                  <li>Controlar tempo dedicado às atividades.</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  2.2. O acesso à Plataforma é realizado exclusivamente pela internet, sendo necessária conexão ativa para sua utilização.
                </p>
                <p className="text-gray-700 mt-4">
                  2.3. A Projetoize reserva-se o direito de atualizar, modificar ou descontinuar funcionalidades da Plataforma a qualquer momento, mediante aviso prévio aos Usuários quando possível.
                </p>
              </section>

              {/* 3. Cadastro e Acesso */}
              <section id="cadastro" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Cadastro e Acesso</h2>
                <p className="text-gray-700 mb-4">
                  3.1. Para utilizar a Plataforma, o Usuário deve realizar cadastro fornecendo informações verdadeiras, completas e atualizadas.
                </p>
                <p className="text-gray-700 mb-4">
                  3.2. O Usuário é responsável por manter a confidencialidade de suas credenciais de acesso (e-mail e senha), respondendo por todas as atividades realizadas em sua conta.
                </p>
                <p className="text-gray-700 mb-4">
                  3.3. Em caso de suspeita de uso não autorizado da conta, o Usuário deve notificar imediatamente a Projetoize através do e-mail contato@projetoize.com.br.
                </p>
                <p className="text-gray-700 mb-4">
                  3.4. É vedado ao Usuário:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Compartilhar credenciais de acesso com terceiros não autorizados;</li>
                  <li>Criar contas utilizando informações falsas ou de terceiros;</li>
                  <li>Utilizar mecanismos automatizados para acessar a Plataforma sem autorização;</li>
                  <li>Tentar acessar áreas restritas ou contas de outros Usuários.</li>
                </ul>
              </section>

              {/* 4. Planos, Preços e Pagamento */}
              <section id="planos" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Planos, Preços e Pagamento</h2>
                <p className="text-gray-700 mb-4">
                  4.1. A Projetoize oferece plano de assinatura com cobrança mensal por usuário Administrador, conforme valores divulgados na página de preços da Plataforma.
                </p>
                <p className="text-gray-700 mb-4">
                  4.2. O plano inclui todas as funcionalidades disponíveis na Plataforma, sem limitação de projetos, tarefas ou usuários Colaboradores.
                </p>
                <p className="text-gray-700 mb-4">
                  4.3. Os pagamentos são processados através de plataformas de pagamento terceirizadas, estando sujeitos aos termos e condições dessas plataformas.
                </p>
                <p className="text-gray-700 mb-4">
                  4.4. A Projetoize reserva-se o direito de alterar os valores dos planos, mediante comunicação prévia de 30 (trinta) dias aos Usuários ativos.
                </p>
                <p className="text-gray-700 mb-4">
                  4.5. O não pagamento da assinatura dentro do prazo poderá resultar na suspensão do acesso à Plataforma, conforme disposto na Seção 9.
                </p>
              </section>

              {/* 5. Período de Teste */}
              <section id="trial" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Período de Teste (Trial)</h2>
                <p className="text-gray-700 mb-4">
                  5.1. Novos Usuários podem utilizar a Plataforma gratuitamente durante o período de teste, conforme prazo divulgado no momento do cadastro.
                </p>
                <p className="text-gray-700 mb-4">
                  5.2. Durante o período de teste, todas as funcionalidades da Plataforma estarão disponíveis sem restrições.
                </p>
                <p className="text-gray-700 mb-4">
                  5.3. Ao término do período de teste, o Usuário deverá contratar um plano pago para continuar utilizando a Plataforma.
                </p>
                <p className="text-gray-700 mb-4">
                  5.4. Caso o Usuário não contrate um plano ao final do período de teste, o acesso à Plataforma será suspenso, permanecendo os dados armazenados por até 90 (noventa) dias.
                </p>
              </section>

              {/* 6. Obrigações do Usuário */}
              <section id="obrigacoes" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Obrigações do Usuário</h2>
                <p className="text-gray-700 mb-4">
                  6.1. O Usuário compromete-se a utilizar a Plataforma de acordo com a legislação vigente, especialmente:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Lei nº 12.965/2014 (Marco Civil da Internet);</li>
                  <li>Lei nº 13.709/2018 (Lei Geral de Proteção de Dados - LGPD);</li>
                  <li>Lei nº 8.078/1990 (Código de Defesa do Consumidor);</li>
                  <li>Lei nº 9.610/1998 (Lei de Direitos Autorais).</li>
                </ul>
                <p className="text-gray-700 mt-4 mb-4">
                  6.2. É vedado ao Usuário:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Utilizar a Plataforma para fins ilícitos ou que violem direitos de terceiros;</li>
                  <li>Inserir conteúdo que seja ilegal, difamatório, obsceno, discriminatório ou que viole direitos autorais;</li>
                  <li>Realizar engenharia reversa, descompilar ou tentar extrair o código-fonte da Plataforma;</li>
                  <li>Transmitir vírus, malware ou qualquer código malicioso;</li>
                  <li>Sobrecarregar intencionalmente os servidores ou interferir no funcionamento da Plataforma;</li>
                  <li>Revender, sublicenciar ou comercializar o acesso à Plataforma sem autorização.</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  6.3. O Usuário é integralmente responsável pelo Conteúdo do Usuário inserido na Plataforma, incluindo sua legalidade e conformidade com direitos de terceiros.
                </p>
              </section>

              {/* 7. Propriedade Intelectual */}
              <section id="propriedade" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Propriedade Intelectual</h2>
                <p className="text-gray-700 mb-4">
                  7.1. A Plataforma, incluindo seu código-fonte, design, marcas, logotipos, textos e demais elementos visuais, são de propriedade exclusiva da Projetoize, protegidos pela legislação de propriedade intelectual.
                </p>
                <p className="text-gray-700 mb-4">
                  7.2. O Usuário recebe uma licença limitada, não exclusiva, intransferível e revogável para utilizar a Plataforma durante a vigência da assinatura.
                </p>
                <p className="text-gray-700 mb-4">
                  7.3. O Conteúdo do Usuário permanece de propriedade do respectivo Usuário. Ao inserir conteúdo na Plataforma, o Usuário concede à Projetoize licença para armazenar, processar e exibir tal conteúdo exclusivamente para a prestação do serviço.
                </p>
                <p className="text-gray-700 mb-4">
                  7.4. A Projetoize não utilizará o Conteúdo do Usuário para fins comerciais, de marketing ou compartilhamento com terceiros, exceto quando necessário para a operação do serviço ou por determinação legal.
                </p>
              </section>

              {/* 8. Limitação de Responsabilidade */}
              <section id="responsabilidade" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitação de Responsabilidade</h2>
                <p className="text-gray-700 mb-4">
                  8.1. A Plataforma é fornecida "como está" (as is). A Projetoize empenhará esforços comercialmente razoáveis para manter a disponibilidade e segurança do serviço, mas não garante:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Disponibilidade ininterrupta da Plataforma;</li>
                  <li>Ausência total de erros, bugs ou vulnerabilidades;</li>
                  <li>Compatibilidade com todos os dispositivos e navegadores.</li>
                </ul>
                <p className="text-gray-700 mt-4 mb-4">
                  8.2. A Projetoize não será responsável por:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Danos decorrentes de caso fortuito ou força maior;</li>
                  <li>Indisponibilidade causada por fatores externos à sua infraestrutura;</li>
                  <li>Uso indevido da Plataforma pelo Usuário;</li>
                  <li>Decisões tomadas pelo Usuário com base nas informações da Plataforma;</li>
                  <li>Perda de dados decorrente de ação ou omissão do Usuário;</li>
                  <li>Danos indiretos, incidentais, especiais ou consequenciais.</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  8.3. Em qualquer hipótese, a responsabilidade total da Projetoize estará limitada ao valor pago pelo Usuário nos últimos 12 (doze) meses de assinatura.
                </p>
              </section>

              {/* 9. Suspensão e Cancelamento */}
              <section id="suspensao" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Suspensão e Cancelamento</h2>
                <p className="text-gray-700 mb-4">
                  9.1. A Projetoize poderá suspender ou cancelar o acesso do Usuário nas seguintes hipóteses:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Inadimplência por período superior a 15 (quinze) dias;</li>
                  <li>Violação destes Termos de Uso;</li>
                  <li>Utilização da Plataforma para fins ilícitos;</li>
                  <li>Determinação judicial ou administrativa;</li>
                  <li>Descontinuação do serviço, mediante aviso prévio de 90 (noventa) dias.</li>
                </ul>
                <p className="text-gray-700 mt-4 mb-4">
                  9.2. O Usuário pode cancelar sua assinatura a qualquer momento através da Plataforma ou solicitando pelo e-mail contato@projetoize.com.br.
                </p>
                <p className="text-gray-700 mb-4">
                  9.3. Em caso de cancelamento pelo Usuário:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>O acesso permanecerá ativo até o final do período já pago;</li>
                  <li>Não haverá reembolso proporcional do período não utilizado;</li>
                  <li>O Usuário poderá exportar seus dados antes do cancelamento efetivo.</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  9.4. Após o cancelamento, os dados do Usuário serão mantidos por até 90 (noventa) dias, podendo ser definitivamente excluídos após esse prazo.
                </p>
              </section>

              {/* 10. Disposições Gerais */}
              <section id="disposicoes" className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Disposições Gerais</h2>
                <p className="text-gray-700 mb-4">
                  10.1. Estes Termos de Uso são regidos pela legislação da República Federativa do Brasil.
                </p>
                <p className="text-gray-700 mb-4">
                  10.2. Fica eleito o foro da comarca do domicílio do Usuário para dirimir quaisquer controvérsias decorrentes destes Termos, em conformidade com o Código de Defesa do Consumidor.
                </p>
                <p className="text-gray-700 mb-4">
                  10.3. A tolerância quanto ao eventual descumprimento de quaisquer das cláusulas e condições não constituirá novação e nem impedirá a exigência de seu cumprimento a qualquer tempo.
                </p>
                <p className="text-gray-700 mb-4">
                  10.4. Se qualquer disposição destes Termos for considerada inválida ou inexequível, as demais disposições permanecerão em pleno vigor e efeito.
                </p>
                <p className="text-gray-700 mb-4">
                  10.5. A Projetoize reserva-se o direito de alterar estes Termos de Uso a qualquer momento, mediante publicação da versão atualizada na Plataforma e comunicação aos Usuários.
                </p>
                <p className="text-gray-700 mb-4">
                  10.6. O uso continuado da Plataforma após a publicação de alterações constitui aceitação dos novos termos.
                </p>
                <p className="text-gray-700 mb-4">
                  10.7. Para esclarecimentos, dúvidas ou solicitações relacionadas a estes Termos, o Usuário pode entrar em contato através do e-mail: <a href="mailto:contato@projetoize.com.br" className="text-primary-600 hover:underline">contato@projetoize.com.br</a>.
                </p>
              </section>

              {/* Aceite */}
              <div className="bg-primary-50 rounded-lg p-6 mt-8">
                <p className="text-gray-700 font-medium">
                  Ao utilizar a Plataforma Projetoize, o Usuário declara ter lido, compreendido e concordado integralmente com estes Termos de Uso.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}
